import { ReactElement } from "react";

import { css, styled } from "@compiled/react";

import Link from "@/components/wpl/link/src";
import { useLocalizedHref } from "@/libraries/web-framework";

type CardProps = {
    content: string;
    href: string;
    icon: ReactElement;
    title: string;
};

const cardStyles = css({
    display: "flex",
    flexDirection: "column",
    width: "11.5rem",

    p: {
        fontSize: "0.75rem",
        lineHeight: "normal",
        color: "#505258",
        margin: 0
    },

    svg: {
        marginBlockEnd: "0.5rem"
    }
});

const Title = styled.h6({
    lineHeight: "normal",
    margin: 0,

    a: {
        color: "#101214",
        fontSize: "0.875rem"
    }
});

export const TitleCard = ({ title, icon, content, href }: CardProps) => {
    const localizedHref = useLocalizedHref(href);

    return (
        <div css={cardStyles}>
            {icon}
            <Title>
                <Link href={localizedHref} type="anchor" text={title} />
            </Title>
            <p>{content}</p>
        </div>
    );
};

type LinkCardProps = {
    href: string;
    text: string;
};

const linkCardStyles = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #DDDEE1",
    borderRadius: "1rem",

    a: {
        "color": "#101214",
        "fontSize": "0.875rem",

        "svg > path": {
            fill: "#101214"
        }
    }
});

export const LinkCard = ({ href, text }: LinkCardProps) => {
    const localizedHref = useLocalizedHref(href);

    return (
        <div css={linkCardStyles}>
            <Link href={localizedHref} text={text} type="basic" />
        </div>
    );
};
